/**
 * RadioGroup
 * Single-select radio list used for Q2 (tech comfort level).
 */
export default function RadioGroup({ options, value, onChange, error }) {
    return (
        <div>
            <div className="mt-1">
                {options.map((opt, i) => {
                    const val    = typeof opt === 'string' ? opt : opt.value;
                    const label  = typeof opt === 'string' ? opt : opt.label;
                    const active = value === val;
                    const isLast = i === options.length - 1;
                    return (
                        <button
                            key={val}
                            type="button"
                            onClick={() => onChange(val)}
                            aria-pressed={active}
                            className="flex items-center gap-2.5 w-full py-2 text-sm text-left"
                            style={{
                                borderBottom: isLast ? 'none' : '0.5px solid #f0f8fd',
                                color: '#1B2F7E'
                            }}
                        >
                            {/* Radio dot */}
                            <div
                                className="flex items-center justify-center flex-shrink-0 rounded-full transition-colors"
                                style={{
                                    width       : 16,
                                    height      : 16,
                                    border      : `1.5px solid ${active ? '#2ECC8E' : '#c5dff0'}`,
                                    background  : active ? '#2ECC8E' : 'white'
                                }}
                                aria-hidden="true"
                            >
                                {active && <div style={{ width: 6, height: 6, borderRadius: '50%', background: 'white' }} />}
                            </div>
                            {label}
                        </button>
                    );
                })}
            </div>
            {error && <p className="text-xs mt-1.5" style={{ color: '#E24B4A' }}>{error}</p>}
        </div>
    );
}
